import "../dpo-my-checklist/dpoMyChecklist.css";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Row } from "antd";
import AddObligations from "../dpo-my-checklist/AddObligations";
import RecordHalf from "../../components/recordHalf/RecordHalf";

import { ReactComponent as ErrorIcon } from "../../assets/error.svg";
import { ReactComponent as GoodIcon } from "../../assets/good.svg";
import { ReactComponent as GreyIcon } from "../../assets/grey-icon.svg";
import { ReactComponent as WaitingIcon } from "../../assets/waiting-for-approval.svg";

import styles from "./myInternal.module.css";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import FilterObligations from "../../components/filterObligations/FilterObligations";
import { filterObligations } from "../../util/filters";
import { sortObligationsBy } from "../../util/sorters";
import { ReactComponent as Triangle } from "../../assets/purple-triangle.svg";
import { isEmpty } from "lodash";

const MyInternal = () => {
  dayjs.extend(customParseFormat);

  const dispatchito = useDispatch();

  const organizationId = useSelector(
    state => state.organizations.organizationId
  );
  const categories = useSelector(
    state => state.organizations?.organizationIdCategories ?? []
  );
  const category = useSelector(state => state.forms?.selectedCategory);
  const searchTerm = useSelector(state => state.forms?.searchTerm);
  const dueDateFrom = useSelector(state => state.forms?.dueDateFrom);
  const dueDateTo = useSelector(state => state.forms?.dueDateTo);
  const selectedAction = useSelector(state => state.forms?.selectedAction);
  const selectedAssessment = useSelector(
    state => state.forms?.selectedAssessment
  );

  const [scrolled , setScrolled] = useState(false);
  const [firstRender , setFirstRender] = useState(false);
  const targetId = useSelector(state => state.internalObligations.navigateId);

  const sortingTypes = ["", "asc", "desc"];
  const [sortingOrder, setSortingOrder] = useState(sortingTypes[0]);
  const [orderBy, setOrderBy] = useState("");

  const originalInternal = useSelector(
    state => state.internalObligations.internalObligations ?? []
  );
  const internalObligations = useSelector(
    state => state.internalObligations.forms ?? []
  );
  const usersData = useSelector(state => state.organizations.usersData);

  const user = useSelector(state => state.user);

  const [currentPage, setCurrentPage] = useState(1);
  const displayedObl =
    category ||
    searchTerm ||
    dueDateFrom ||
    dueDateTo ||
    selectedAction ||
    selectedAssessment
      ? filterObligations({
          obligationList: originalInternal,
          flag: "internal",
          filters: {
            category,
            searchTerm,
            action: selectedAction,
            assessment: selectedAssessment,
            dueDateFrom,
            dueDateTo
          }
        })
      : originalInternal;
  const startIndex = (currentPage - 1) * 5;
  const endIndex = startIndex + 5;
  const sortedDisplayedObl =
    sortingOrder || orderBy
      ? !isEmpty(internalObligations) && !isEmpty(displayedObl)
        ? sortObligationsBy(
            displayedObl,
            "internal",
            orderBy,
            sortingOrder
          )?.map(o => {
            const relevantObligation = internalObligations?.find(
              obl => o._id === obl._id
            );
            return relevantObligation;
          })
        : sortObligationsBy(displayedObl, "internal", orderBy, sortingOrder)
      : displayedObl?.map(o => {
          const relevantObligation = internalObligations?.find(
            obl => o._id === obl._id
          );
          return relevantObligation;
        });
  const displayedItems =
    sortedDisplayedObl && sortedDisplayedObl.slice(startIndex, endIndex);
  const currentUsersData =
    usersData?.filter(
      b => b._id === user.userId || b.role === "corporateComplianceAssessor"
    ) ?? [];

  const panelStyle = {
    marginBottom: 24,
    borderRadius: 16,
    border: "none"
  };

  const toggleOrder = () => {
    const currentIndex = sortingTypes.indexOf(sortingOrder);
    const nextIndex = (currentIndex + 1) % sortingTypes.length;
    setSortingOrder(sortingTypes[nextIndex]);
    return sortingTypes[nextIndex];
  };

  const handleSortClick = by => {
    if (orderBy !== by) {
      setSortingOrder("asc");
    } else {
      toggleOrder();
    }
    setOrderBy(by);
  };

  const handleClearMessage = ({ event, id, key, type }) => {
    const index = internalObligations.findIndex(item => item._id === id);
    dispatchito({
      type: "UPDATE_INTERNAL_OBLIGATION_FORMS",
      payload: { index, event, key }
    });
  };

  const handleChangeAddObl = ({ event, id, key, type }) => {
    const index = internalObligations.findIndex(item => item._id === id);
    const value =
      type === "select"
        ? event
        : type === "date"
        ? new Date(event).toISOString()
        : event.target.value;
    dispatchito({
      type: "UPDATE_INTERNAL_OBLIGATION_FORMS",
      payload: { index, value, key }
    });
  };

  const countCompliantTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Compliant").length;
  const countCompletedTasks = itemList =>
    itemList && itemList.filter(item => item.action === "Completed").length;
  const countPendingTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Pending").length;
  const countPartialTasks = itemList =>
    itemList && itemList.filter(item => item.assessment === "Partially").length;
  const countNonCompliantTasks = itemList =>
    itemList &&
    itemList.filter(item => item.assessment === "Non-Compliant").length;



    useEffect(() => {
      if (targetId === 0 && scrolled) {
        if(firstRender){
          setCurrentPage(1);
          // setSortingOrder(sortingTypes[0]);
          // setOrderBy("");
        }
        setFirstRender(true);
      }
    }, [organizationId, category, searchTerm, dueDateFrom, dueDateTo, selectedAction, selectedAssessment]);
  

  // useEffect(() => {
  //   setCurrentPage(1);
  // }, [
  //   organizationId,
  //   category,
  //   searchTerm,
  //   dueDateFrom,
  //   dueDateTo,
  //   selectedAction,
  //   selectedAssessment
  // ]);

  return (
    <div className="ob" id="ob-page">
      <FilterObligations
        defaultCat={""}
        organizationId={organizationId}
        sortedUniqueMainCategories={
          categories
            ? categories
                ?.filter(option =>
                  internalObligations?.some(obl => obl?.mainCategory === option)
                )
                ?.map(option => {
                  return { value: option, label: option };
                })
            : []
        }
        obligationType="internal"
      />
      <div
        className={styles.fourHalfs}
        id={`ob-page-${styles.fourHalfs}`}
        style={{ marginTop: "3.125rem" }}
      >
        <RecordHalf
          id="ob-page-record-half"
          number={countCompletedTasks(internalObligations)}
          icon={<GoodIcon />}
          numberColor="#58AB5C"
          // percentage={myObligations.length !== 0 ? (myObligations.length-countCompliantTasks(myObligations))*100/myObligations.length : "NaN"}
          // percentageText="remaining to complete target"
          firstLine="Actions"
          secondLine="Completed"
          // thirdLine="this month"
          secondNumber={internalObligations && internalObligations.length}
          actions={true}
        />
        <RecordHalf
          id="ob-page-record-half4"
          number={countPendingTasks(internalObligations)}
          icon={<GreyIcon />}
          numberColor="grey"
          // percentage={myObligations.length !== 0 ? countCompliantTasks(myObligations)*100/myObligations.length : 0}
          // percentageText="of target achieved"
          firstLine="Pending"
          secondLine="Tasks"
          // thirdLine="this month"
        />
        <RecordHalf
          id="ob-page-record-half2"
          number={countNonCompliantTasks(internalObligations)}
          icon={<ErrorIcon />}
          numberColor="#b00020"
          // percentage={myObligations.length !== 0 ? (myObligations.length-countCompliantTasks(myObligations))*100/myObligations.length : "NaN"}
          // percentageText="remaining to complete target"
          firstLine="Non-Compliant"
          secondLine="Tasks"
          // thirdLine="this month"
        />
        <RecordHalf
          id="ob-page-record-half3"
          number={countPartialTasks(internalObligations)}
          icon={<WaitingIcon />}
          numberColor="#E78F0B"
          // percentage={96}
          // percentageText="of target achieved"
          firstLine="Partially Compliant"
          secondLine="Tasks"
          // thirdLine="this month"
        />
        <RecordHalf
          id="ob-page-record-half4"
          number={countCompliantTasks(internalObligations)}
          icon={<GoodIcon />}
          numberColor="#58AB5C"
          // percentage={myObligations.length !== 0 ? countCompliantTasks(myObligations)*100/myObligations.length : 0}
          // percentageText="of target achieved"
          firstLine="Compliant"
          secondLine="Tasks"
          // thirdLine="this month"
        />
      </div>
      <Row
        className="mt-3 mb-3"
        id="ob-page-mt-3-mb-3"
        gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
      ></Row>

      {/* --------------Internal Regulations & Frameworks -------------------------------*/}

      <div className="shaded-border" id="ob-page-shaded-border">
        <div className="obligation-table" id="ob-page-obligation-table">
          <div className="large-titles-black" id="ob-page-large-titles-black">
            Internal Obligations{" "}
          </div>
          <Row
            className="mb-2 internal-obl-header"
            id="ob-page-mb2-internal-obl-header"
            gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
          >
            <Col></Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-id-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style"
                style={{ paddingLeft: "0.438rem", marginLeft:"0.5rem" }}
                onClick={() => handleSortClick("code")}
              >
                ID
                {orderBy === "code" && sortingOrder ? (
                  sortingOrder === "desc" ? (
                    <Triangle />
                  ) : (
                    <Triangle style={{ transform: "rotate(180deg)" }} />
                  )
                ) : (
                  <></>
                )}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-category-col"
            >
              <span
                className="title-style sortable"
                id="ob-page-title-style-3"
                style={{ paddingLeft: "0.375rem", marginLeft:"0.313rem" }}
                onClick={() => handleSortClick("mainCategory")}
              >
                Category{orderBy === "mainCategory" && sortingOrder ? sortingOrder === "desc" ? <Triangle/> : <Triangle style={{transform: "rotate(180deg)"}}/> : <></>}
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-obligation-col"
            >
              <span
                className="title-style"
                id="ob-page-title-style-6"
                style={{ paddingLeft: "0.438rem", marginLeft:"1rem" }}
              >
                Obligation
              </span>
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-action-col"
            >
              <span className="title-style" id="ob-page-title-style-7" style={{marginLeft:"-0.438rem"}}>
                Action
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-assessment-col"
            >
              <span className="title-style" id="ob-page-title-style-8" style={{marginLeft:"-0.375rem"}}>
                Assessment
              </span>
            </Col>
            <Col
              // span={3}
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-end",
                paddingRight: 0,
                paddingLeft: 0
              }}
              className="internal-due-col"
            >
              <span className="title-style" id="ob-page-title-style-9" style={{marginLeft:"0.625rem"}}>
                Due Date
              </span>
            </Col>
            {/* <Col 
            // span={4} 
            className="internal-comments-col"
            id="ob-page-internal-comments-col"
            style={{ display: "flex" }}>
              <span className="title-style">Comments</span>
            </Col> */}
            <Col
              // span={4}
              className="internal-submit-col"
              id="internal-submit-col"
              style={{ display: "flex" }}
            >
              <span></span>
            </Col>
          </Row>

          <AddObligations
            id="ob-page-add-obligations"
            handleChangeAddObl={handleChangeAddObl}
            handleClearMessage={handleClearMessage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            displayedObl={displayedObl}
            displayedItems={displayedItems ?? []}
            usersData={currentUsersData || []}
            panelStyle={panelStyle}
            addObligations={displayedObl}
            // setAddObligations={setAddObligations}
            myTask={true}
            organization={user.organization}
            scrolled={scrolled}
            setScrolled={setScrolled}
          />

          <div className="collapse-margin" id="ob-page-collapse-margin">
            {" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyInternal;
